import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../Components/Navbar/navbar'
import Footer from '../../Components/Footer/footer'

export default function MyOrder() {

    const [orderData, setOrderData] = useState({})

    const fetchMyOrder = async () => {

        if (localStorage.getItem('userEmail')) {
            await fetch("http://localhost:8000/order/yourOrders", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: localStorage.getItem('userEmail')
                })
            }).then(async (res) => {
                let response = await res.json()
                setOrderData(response)
            })
        } else {
            alert('email not found')
            localStorage.removeItem('userEmail')
        }



    }

    useEffect(() => {
        fetchMyOrder()
    }, [])

    return (
        <>
            <Navbar />
       {orderData !== {}
                    ?
                Array(orderData).map((data,index) => {
                    return (
                        <div key={index}>
                            {
                                data.orderData
                            ?
                                data.orderData.order_data.slice(0).reverse().map((item) => {
                                    return (                                        
                                        item.map((arrayData,i) => {
                                            return (
                            <div key={i}>
                                {arrayData.Order_date
                                                        ?
                                                        <div className='container-fluid'>
                                                            <br />                    
                                                        <div className='d-flex justify-content-between'>
                                                            <h6>Date: {data = new Date(arrayData.Order_date).toLocaleString()}</h6>
                                                            <h6>Total Amount:{arrayData.totalAmount}</h6>
                                                                <h6>Payment Status: {arrayData.paymentStatus}</h6>
                                                                <h6>Delivery Status: {arrayData.deliveryStatus}</h6>
                                                                <hr />
                                                            </div>
                                                        </div>
                                    
                                                        :
                                    
                                                        <div className='container m-auto mt-5 table-responsive  table-responsive-sm table-responsive-md' >
                                        
                                                            <table className='table table-hover '>

                                                                <tbody >
                                                                    

                                                                    <tr>

                                                                        <th scope='row' >{i}</th>
                                                                        <td  ><img src={`http://localhost:8000/public/images/${arrayData.productImage}`} width='40px' height='40px' alt="..." /></td>
                                                                        <td  >{arrayData.productTitle}</td>
                                                                        <td >{arrayData.productType}</td>
                                                                        <td >{arrayData.productQuantity}mg</td>
                                                                        <td >₹{arrayData.productAmount}</td>

                                                                    </tr>

                                                                </tbody>

                                                            </table>

                                                        </div>


                                                    }

                                                </div>
                                                
                            )
                                        })

                            )
                                }) : <><div className='text-center p-5'>sorry no data is available</div>
                                <div className=' text-center p-5'><Link to='/medici'>Order Some Medicines First</Link></div>
                                </>
                            }
                        </div>
                    )
                    }) : <div className='text-center'>sorry no data is available</div>}
            <Footer />


        </>
    )
}
